var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-responsive',_vm._g(_vm._b({staticClass:"base-divider",class:_vm.classes,attrs:{"max-width":"28"}},'v-responsive',_vm.$attrs,false),_vm.$listeners),[_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }